import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {ChatMessage, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {CitedMessage as CitedMessageBase} from '@components/common/base/chat-message'
import {useMessageData} from '@components/right-panel/chat/chat-messages/message/utils'
import {useFileClick} from '@components/right-panel/chat/chat-messages/message/utils/use-file-click'

const TwCitedMessage = tw.div`
  flex-none
  px-16
  py-8
  bg-personal-message
  border-solid
  border-b-1
  border-x-0
  border-grey-l100
`

interface Props {
  hub?: Hub
  message: ChatMessage
  onClose?: () => void
  onDelete?: () => void
}

export const CitedMessage = observer(
  ({hub, message, onClose, onDelete}: Props) => {
    const box = Sync.getOrCurrent(hub)
    const data = useMessageData({box, msg: message})
    const onFileClick = useFileClick()
    return data ? (
      <TwCitedMessage>
        <CitedMessageBase
          data={data}
          heightRestricted
          onDelete={onDelete}
          onClose={onClose}
          onFileClick={onFileClick}
          filesHeightRestricted
        />
      </TwCitedMessage>
    ) : null
  }
)
